export const ResolvedAbsenceRequestStates = {
  approved: 'approved_office',
  rejected: 'rejected_office',
} as const
